import { Box, Button, CircularProgress, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import html2pdf from "html2pdf.js";
import AdvanceDetails from "./ViewTenderDetails/AdvanceDetails";
import IntermediateDetails from "./ViewTenderDetails/IntermediateDetails";
import BasicDetails from "./ViewTenderDetails/BasicDetails";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import PaidIcon from "@mui/icons-material/Paid";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { useDownloadExcel } from "react-export-table-to-excel";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { handleExportPDF } from "../../utils/exportToPDF";

const ViewTenderDetails = () => {
  const [tender, setTender] = useState();
  const [workItems, setWorkItems] = useState();
  const vendorId = JSON.parse(localStorage.getItem("vendor"));
  const { tenderId } = useParams();
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const pdfRef = useRef();
  const tableRef = useRef(null);
  const [exporting, setExporting] = useState(false)

  useEffect(() => {
    const getTender = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/vendor-tender/get-tender?tenderId=${tenderId}&vendorId=${vendorId}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setTender(res.data);
        setWorkItems(res.data.workItemDetails);
        setIsLoading(false);
      } catch (error) {
        console.error("Error updating tender status:", error);
      }
    };
    getTender();
  }, []);

  const { onDownload } = useDownloadExcel({
    currentTableRef: tender && tableRef.current,
    filename: "BOQ",
    sheet: "BOQ",
  });

  return (
    <>
      <Box sx={{ display: "flex", justifyContent: "end", gap: 2 }}>
        {!tender?.isSingleBid && tender?.vtStatus && tender.vtStatus !== "SHORTLISTED" && (
          <div
            className="tender-card"
            style={{
              background: "#FFF5E0",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-around",
              cursor: "pointer",
            }}
            onClick={() =>
              navigate(`/vendor/dashboard/${tenderId}/view-qualification`)
            }
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <div
                style={{
                  borderRadius: "50%",
                  background: "#fff",
                  padding: "10px",
                  display: "inline-flex",
                  alignItems: "center",
                }}
              >
                <PersonOutlineOutlinedIcon />
              </div>
            </div>
            <Typography fontWeight={600}>View Vendor Qualification</Typography>
          </div>
        )}

        {tender?.vtStatus &&
          ([
            "EMD_CMD_ACCEPTED",
            "EMD_CMD_SUBMITTED",
            "BID_OPEN",
            "BID_CLOSED",
            "BID_SUBMITTED",
            "REBID",
            "AWARDED",
          ].includes(tender.vtStatus) ||
            (!tender?.isSingleBid && tender?.vtStatus === "DISQUALIFIED" &&
              tender?.stage !== "BUYER")) && (
            <div
              className="tender-card"
              style={{
                background: "#E0F8EA",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-around",
                cursor: "pointer",
              }}
              onClick={() => navigate(`/vendor/dashboard/${tenderId}/view-emd`)}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "end",
                }}
              >
                <div
                  style={{
                    borderRadius: "50%",
                    background: "#fff",
                    padding: "10px",
                    display: "inline-flex",
                    alignItems: "center",
                  }}
                >
                  <PaidIcon />
                </div>
              </div>
              <Typography fontWeight={600}>View EMD Submitted</Typography>
            </div>
          )}

        {(["BID_CLOSED", "BID_SUBMITTED", "REBID", "AWARDED"].includes(
          tender?.vtStatus
        ) ||
          (tender?.vtStatus === "DISQUALIFIED" &&
            tender?.stage !== "FINANCE_HEAD" &&
            tender?.stage !== "BUYER")) && (
          <>
            <div
              className="tender-card"
              style={{
                background: "#EFE6F6",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-around",
                cursor: "pointer",
              }}
              onClick={() =>
                navigate(`/vendor/dashboard/${tenderId}/view-bids`)
              }
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "end",
                }}
              >
                <div
                  style={{
                    borderRadius: "50%",
                    background: "#fff",
                    padding: "10px",
                    display: "inline-flex",
                    alignItems: "center",
                  }}
                >
                  <ShowChartIcon />
                </div>
              </div>
              <Typography fontWeight={600}>View Bid Submitted</Typography>
            </div>
          </>
        )}
        <div
          className="tender-card"
          style={{
            background: "#FCEAE4",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-around",
            cursor: "pointer",
          }}
          onClick={() => navigate(`/vendor/dashboard/${tenderId}/view-query`)}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "end",
            }}
          >
            <div
              style={{
                borderRadius: "50%",
                background: "#fff",
                padding: "10px",
                display: "inline-flex",
                alignItems: "center",
              }}
            >
              <DescriptionOutlinedIcon />
            </div>
          </div>
          <Typography fontWeight={600}>Queries</Typography>
        </div>
      </Box>
      {exporting && <div className="uploading-div">Exporting PDF, this may take a while. <CircularProgress color="#fff" /></div>}
      <div style={{ display: "flex", justifyContent: "end", gap: "20px" }}>
        {tender && (tender.vtStatus !== "SHORTLISTED" && tender.vtStatus !== "QDETAILS_SUBMITTED" && tender.vtStatus !== "QSTAGE_1" && tender.vtStatus !== "QSTAGE_2") &&
        <Button
          className="btn-contained"
          sx={{ width: "200px" }}
          onClick={onDownload}
        >
          Download BOQ Excel
        </Button>}
        <Button
          className="btn-contained"
          sx={{ width: "200px" }}
          onClick={async () => {
            try {
              setExporting(true)
              await handleExportPDF(pdfRef, "Tender_Details")
            } catch (error) {
              console.log(error)
            } finally {
              setExporting(false)
            }
          }}
        >
          Export PDF
        </Button>
      </div>
      {isLoading ? (
        <Box textAlign={"center"}>
          <CircularProgress />
        </Box>
      ) : tender &&
        (tender?.vtStatus === "EMD_CMD_ACCEPTED" ||
          tender?.vtStatus === "AWARDED" ||
          tender?.vtStatus === "REBID" ||
          tender?.vtStatus === "BID_SUBMITTED" ||
          tender?.vtStatus === "BID_OPEN" ||
          tender?.vtStatus === "DISQUALIFIED") ? (
        <div ref={pdfRef}>
          <AdvanceDetails
            tender={tender}
            workItems={workItems}
            storedUser={storedUser}
          />
        </div>
      ) : tender?.vtStatus === "EMD_CMD_SUBMITTED" ||
        tender?.vtStatus === "QUALIFIED" ? (
        <div ref={pdfRef}>
          <AdvanceDetails
            tender={tender}
            workItems={workItems}
            storedUser={storedUser}
            tableRef={tableRef}
          />
        </div>
      ) : (
        <div ref={pdfRef}>
          <BasicDetails tender={tender} />
        </div>
      )}
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Button
          className="btn-outlined"
          onClick={() => navigate("/vendor/dashboard")}
        >
          Back
        </Button>
      </Box>
    </>
  );
};

export default ViewTenderDetails;
